// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1383":"46ce896b","3307":"07740f9a","6026":"46ce896b","8725":"f541b781"}[chunkId] + ".chunk.css";
};